import { IsUUID, IsNotEmpty } from 'class-validator';

export class GetSubstituteAbsenceOptionsDto {
  @IsUUID()
  @IsNotEmpty()
  employeeId: string;
}
